
  /**
   * =============================
   * ===== END COMPONENTS JS =====
   * =============================
   */

})(jQuery, Drupal);
